<template>
  <tr
    :class="{
      'bg-light-primary': item.idGuiaFechasLibres < 0
    }"
  >
    <td>
      {{ item.guia }}
    </td>
    <td v-for="num in numDays" :key="num" class="text-center table-field-icon"
      :class="{
        'table-warning': sundays.includes(num)
      }"
    >
      <label :for="`check-${item.idGuiaFechasLibres}-${num}`" style="height:100%;width:100%;margin:0;padding:0;">
        <input type="checkbox" v-model="days" :value="num" :id="`check-${item.idGuiaFechasLibres}-${num}`">
      </label>
    </td>
    <td>
      <div class="text-nowrap">
        <button class="btn btn-xs btn-icon btn-light-primary" @click="onSave">
          <i class="fa fa-fw fa-save"></i>
        </button>
        <button class="btn btn-xs btn-icon btn-light-danger ml-1" @click="onDelete">
          <i class="fa fa-fw fa-trash"></i>
        </button>
        <button class="bg-white border-0 text-primary ml-1" @click="checkAll">
          Todo
        </button>
        <button class="bg-white border-0 text-primary ml-1" @click="removeAll">
          Nada
        </button>
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  props: {
    item: Object,
    numDays: Number,
    sundays: Array,
    idModule: Number,
    month: String,
  },
  data () {
    return {
      days: this.item.diasTrabajo || []
    }
  },
  methods: {
    async onDelete () {
      const vm = this;

      let result = await vm.$swal.fire('', '¿Seguro que desea eliminar este item?', 'question')

      if (result.value) {
        if (vm.item?.idGuiaFechasLibres < 0 ) {
          return vm.$emit('delete', vm.item.idGuiaFechasLibres);
        }
  
        vm.axios.delete(`/programacion/guias/${vm.item.idGuiaFechasLibres}`)
        .then(response => {
          return vm.$emit('delete', vm.item.idGuiaFechasLibres);
        })
        .catch(error => {
  
        })
      }

    },
    onSave () {
      const vm = this;
      const fd = {
        days: vm.days,
        idGuia: vm.item.idGuia,
        month: vm.month,
        idModule: vm.idModule,
        _method: 'POST'
      }
      let endpoint = '/programacion/guias';

      if (vm.item.idGuiaFechasLibres > 0) {
        endpoint = `/programacion/guias/${vm.item.idGuiaFechasLibres}`;
        fd._method = 'PUT';
      }

      vm.axios.post(endpoint, fd)
      .then(response => {
        vm.$toast.fire('Registro guardado', '', 'success');
        if (vm.item.idGuiaFechasLibres < 0) {
          vm.item.idGuiaFechasLibres = response.data.content;
        }

        vm.$emit('save', vm.item.idGuiaFechasLibres, vm.days);
      })
      .catch(error => {
        vm.$toast.fire(error.response.data.message, '', 'error');
      })
    },
    checkAll () {
      const vm = this;
      let days = [];
      for (let i = 1; i <= vm.numDays; i++) {
        days.push(i);
      }
      vm.days = days;
    },
    removeAll () {
      this.days = [];
    },
  }
}
</script>